// const HistoryService = process.env.MOCKING === 'true'
//     ? require('./HistoryService/Mock').default
//     : require('./HistoryService/Service').default;

const HistoryService = require('./HistoryService/Service').default;

export default HistoryService;
